module.exports = __webpack_public_path__ + "img/banner-03.82b59e1c.jpg";